import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import Cookies from 'js-cookie';

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    loadingStatus: 'idle',
    error: null,
    token: Cookies.get('token') || null,
    isAuthenticated: false,
    isSessionExpired: false,
}

export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async ({email, password}, { rejectWithValue }) => {
        try {
            const body = {email, password};

            const response = await request(
                `${APP_URL}/login`,
                'POST',
                body,
            );

            const token = response.data.token;

            Cookies.set('token', token, { path: '/', expires: 1 });

            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const logoutUser = createAsyncThunk(
    'auth/logoutUser',
    async() => {
        try {
            const token = Cookies.get('token');

            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const response = await request(
                `${APP_URL}api/logout`,
                'POST',
                {},
                customHeaders
            );

            return response;
        } catch (error) {
            return error.response;
        } finally {
            Cookies.remove('token', { path: '/', expires: 1 });
        }
    }
)

export const changePassword = createAsyncThunk(
    'auth/changePassword',
    async ({credentials, token}, { rejectWithValue }) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const body = {
                old_password: credentials.old_password,
                new_password: credentials.new_password,
                new_password_confirmation: credentials.new_password_confirmation
            };

            const response = await request(
                `${APP_URL}/change-password`,
                'POST',
                body,
                customHeaders
            );

            return response;
        } catch (error) {
            console.log("Error in loginUser:", error);
            return rejectWithValue(error);
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setSessionExpired: (state) => {
            state.isSessionExpired = true;
        },
        clearSessionExpired: (state) => {
            state.isSessionExpired = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, state =>  {
                state.loadingStatus = 'loading';
                state.isAuthenticated = false;
                state.token = null;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loadingStatus = 'idle';
                state.isAuthenticated = true;
                state.token = Cookies.get("token");
                state.error = null;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loadingStatus = 'rejected';
                state.isAuthenticated = false;
                state.token = null;
                state.error = action.payload;
            })
            .addCase(logoutUser.fulfilled, (state, action) => {
                state.isAuthenticated = false;
                state.user = null;
                state.token = null;
                state.error = null;
            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.error = action.payload;
            })
    },
});

export const { setAuthenticated, showAlert, clearAlert, setSessionExpired, clearSessionExpired } = authSlice.actions;

export default authSlice.reducer;